export const CONFIGURATIONS = [
    {
        key: "1-bhk",
        name: "1 BHK",
        area: "520 sq.ft. carpet",
        price: "₹49.99 Lacs",
        priceNote: "+ Govt Taxes",
        blurb: "Compact yet stylish homes with a private sun deck — ideal for young professionals, first-time buyers and investors looking at 1 BHK flats in Shilphata.",
        plan: "fp5",
        path: "/1-bhk/",
    },
    {
        key: "2-bhk",
        name: "2 BHK",
        area: "715 sq.ft. carpet",
        price: "₹69.99 Lacs",
        priceNote: "+ Govt Taxes",
        blurb: "Perfect for small and growing families — sunlit interiors, ample storage and wide balconies, among the most spacious 2 BHK flats in Shilphata.",
        plan: "fp9",
        path: "/2-bhk/",
    },
    {
        key: "3-bhk",
        name: "3 BHK",
        area: "1080 sq.ft. carpet",
        price: "₹1.40 Cr",
        priceNote: "All Inclusive",
        blurb: "Luxurious and expansive residences for ultimate comfort — the largest homes at Atlanta Enclave, crafted for families that want more of everything.",
        plan: null,
        path: "/3-bhk/",
    },
];

export const HIGHLIGHTS = [
    { value: "8 Acres", label: "Gated community with five elegant towers" },
    { value: "60%+", label: "Landscaped gardens and open spaces" },
    { value: "MIVAN", label: "Advanced construction technology" },
    { value: "Since 1977", label: "Trusted legacy of Atlanta Limited" },
];

export const AMENITIES = [
    { name: "Swimming Pool", desc: "Relax with family and friends.", image: "pool", alt: "Swimming pool at Atlanta Enclave Shilphata" },
    { name: "Clubhouse", desc: "Socialize and unwind in style.", image: "clubhouse", alt: "Clubhouse at Atlanta Enclave Shilphata" },
    { name: "Gym & Fitness Center", desc: "Stay active with modern equipment.", image: "gym", alt: "Gym and fitness center at Atlanta Enclave Shilphata" },
    { name: "Children's Play Area", desc: "Safe and fun for kids.", image: "kids-play", alt: "Children's play area at Atlanta Enclave Shilphata" },
    { name: "Yoga Room", desc: "A calm, dedicated space for yoga and meditation.", image: "yoga", alt: "Yoga room at Atlanta Enclave Shilphata" },
    { name: "Senior Citizens Zone", desc: "A quiet, comfortable corner for senior residents.", image: "senior-zone", alt: "Senior citizens zone at Atlanta Enclave Shilphata" },
    { name: "EV Charging Station", desc: "Future-ready charging for electric vehicles.", image: "ev-charging", alt: "EV charging station at Atlanta Enclave Shilphata" },
    { name: "Landscaped Pergolas", desc: "Shaded sit-outs within serene landscaped gardens.", image: "pergolas", alt: "Landscaped pergolas at Atlanta Enclave Shilphata" },
];

export const AMENITY_LIST = [
    "Clubhouse",
    "Swimming Pool",
    "Gym & Fitness Center",
    "Children's Play Area",
    "Landscaped Gardens",
    "Yoga Room",
    "Senior Citizens Zone",
    "EV Charging Station",
    "24/7 Security with CCTV Surveillance",
    "Gated Community with Secure Entry Points",
];

export const CONNECTIVITY = [
    ["Kalyan Shil Road", "1 min"],
    ["Shilphata Junction", "2 mins"],
    ["Mahape Shil Road", "7 mins"],
    ["Ghansoli Railway Station", "10 mins"],
    ["Mumbra TMC Sports Complex", "11 mins"],
    ["Thane Railway Station", "15 mins"],
    ["Mumbai via Eastern Express Highway & Airoli", "20 mins"],
    ["Kharghar–Kalyan Monorail", "22 mins"],
    ["Majiwada Junction", "33 mins"],
    ["Ghatkopar–Ghansoli Link Road", "37 mins"],
    ["Navi Mumbai Airport", "43 mins"],
];

export const FAQS = [
    {
        q: "Where is Atlanta Enclave located?",
        a: "Atlanta Enclave is located at Opp. Dutta Mandir, Kalyan Shilphata, Mumbai-Pune Road, Thane – 400612. Shilphata Junction is just 2 minutes away, with seamless connectivity to Mumbai, Navi Mumbai, Thane and Pune.",
    },
    {
        q: "What configurations are available at Atlanta Enclave Shilphata?",
        a: "Atlanta Enclave offers premium 1 BHK (520 sq.ft. carpet), 2 BHK (715 sq.ft. carpet) and 3 BHK (1080 sq.ft. carpet) apartments, all built with advanced MIVAN construction technology.",
    },
    {
        q: "What is the price of flats in Atlanta Enclave?",
        a: "1 BHK homes start at ₹49.99 Lacs + government taxes, 2 BHK homes at ₹69.99 Lacs + government taxes, and 3 BHK residences at ₹1.40 Cr all inclusive. Prices are subject to change and flexible payment plans are available — enquire for the latest cost sheet.",
    },
    {
        q: "Is Atlanta Enclave RERA registered?",
        a: "Yes. Atlanta Enclave is registered with MahaRERA under registration number P51700077788, verifiable on maharera.mahaonline.gov.in.",
    },
    {
        q: "What amenities does Atlanta Enclave offer?",
        a: "The 8-acre gated community offers a clubhouse, swimming pool, gym and fitness center, children's play area, yoga room, senior citizens zone, landscaped gardens with pergolas, EV charging stations and 24/7 security with CCTV surveillance.",
    },
    {
        q: "Who is the developer of Atlanta Enclave?",
        a: "Atlanta Enclave is developed by Atlanta Limited, a trusted name in real estate delivering quality projects since 1977.",
    },
    {
        q: "How can I book a site visit?",
        a: "Call +91 88798 56585, message us on WhatsApp, or fill the enquiry form and our team will schedule your site visit.",
    },
];

export const FLOOR_PLAN_GROUPS = [
    { label: "1 BHK", images: ["fp2", "fp3", "fp4", "fp5", "fp6"] },
    { label: "2 BHK", images: ["fp", "fp1", "fp7", "fp8", "fp9", "fp10"] },
];
